import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import ContentModule from "../../modules/content_module";
import {RenderComponent} from "../../modules/render-component";

import "./LeadooScript.scss";

const LeadooScript = ({Module, type}) => {
    const renderComponent = RenderComponent()

    return (
        <>
        {Module?.script_code &&
            <section className={`leadoo-script ${Module.bgrd_color ? Module.bgrd_color.toLowerCase() : "" } ${Module?.leadoo_padd}`}>
                <Container>
                    <Row>
                        <Col>
                            {Module?.title && 
                                <h2>{Module?.title}</h2>
                            }
                            {type === "banner" ?
                                Module.script_code && <ContentModule Content={Module.script_code} />
                            :
                                (Module.script_code && renderComponent === "true") ? <ContentModule Content={Module.script_code} /> : ""
                            }

                            {Module?.content && <ContentModule Content={Module?.content}/> }
                        </Col>
                    </Row>
                </Container>
            </section>
        }
        </>
    );
};
export default LeadooScript;